import { MotifTooltip } from "@ey-xd/motif-react";

type Props = {
  message: string;
  triggerString: string;
  errorSkuList: string[];
};

export default function EngagementErrorTooltip({
  message,
  triggerString,
  errorSkuList,
}: Props) {
  const listItems = errorSkuList.map((error) => <li>{error}</li>);
  return (
    <>
      <MotifTooltip
        contentClassName="tooltip-content"
        allowHover
        allowClick
        id={`tooltip`}
        placement="auto"
        usePortal
        variant="default"
        trigger={triggerString + "  "}
      >
        {message}
        <ol>{listItems}</ol>
      </MotifTooltip>
    </>
  );
}
